<template>
  <header class="user-section-header">
    <div class="user-section-header__copy">
      <p class="user-section-header__kicker">
        <span aria-hidden="true"></span>
        {{ eyebrow }}
      </p>
      <h1>{{ title }}</h1>
      <p v-if="description" class="user-section-header__description">{{ description }}</p>
    </div>

    <div v-if="$slots.actions" class="user-section-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'UserSectionHeader',
  props: {
    eyebrow: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Montserrat:wght@700;900&display=swap');

.user-section-header {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 720px) auto;
  gap: 20px;
  align-items: start;
  margin: 0 0 clamp(26px, 5vw, 48px);
  color: var(--ff-black, #111110);
  font-family: 'DM Sans', sans-serif;
}

.user-section-header__copy {
  min-width: 0;
}

.user-section-header .user-section-header__kicker {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 0 12px;
  padding: 0;
  color: var(--ff-muted, var(--ff-gray-2, #5f5e5a));
  font-family: 'DM Sans', sans-serif;
  font-size: 0.76rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.2em;
  text-align: left;
  text-transform: uppercase;
}

.user-section-header__kicker span {
  display: inline-block;
  width: 34px;
  height: 3px;
  flex: 0 0 auto;
  background: var(--ff-red, #d50b35);
}

.user-section-header .user-section-header__copy h1 {
  margin: 0;
  padding: 0;
  color: var(--ff-black, #111110);
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(2.35rem, 7vw, 4.7rem);
  font-style: normal;
  font-weight: 900;
  line-height: 0.92;
  letter-spacing: -0.07em;
  text-align: left;
  text-transform: uppercase;
}

.user-section-header .user-section-header__description {
  max-width: 610px;
  margin: 20px 0 0;
  padding: 0;
  color: var(--ff-muted, var(--ff-gray-2, #5f5e5a));
  font-family: 'DM Sans', sans-serif;
  font-size: clamp(1rem, 2vw, 1.12rem);
  font-style: normal;
  font-weight: 400;
  line-height: 1.55;
  letter-spacing: normal;
  text-align: left;
  text-transform: none;
}

.user-section-header__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 1px;
}

@media (max-width: 620px) {
  .user-section-header {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px;
    margin-bottom: 25px;
    padding: 0 7px;
  }

  .user-section-header .user-section-header__copy h1 {
    max-width: 355px;
    font-size: clamp(2rem, 11.2vw, 2.85rem);
    line-height: 0.93;
  }

  .user-section-header .user-section-header__description {
    margin-top: 15px;
    font-size: 0.98rem;
    line-height: 1.48;
  }
}

@media (max-width: 420px) {
  .user-section-header {
    grid-template-columns: minmax(0, 1fr);
  }

  .user-section-header__actions {
    justify-content: flex-start;
  }
}

@media (max-width: 320px) {
  .user-section-header .user-section-header__copy h1 {
    max-width: none;
    font-size: clamp(1.55rem, 8.5vw, 1.85rem);
    overflow-wrap: break-word;
  }
}
</style>
